<template>
    <div class="vue timparty-countdown " v-if="distance > 0">

        <div v-if="heading" class="heading w-100 d-block">{{ heading }}</div>
        <div class="d-flex align-items-top justify-content-center">

        <div class="text-center">

          <div class="row no-gutters" v-if="days >= 100">
            <div class="col-4">
              <div class="group-digit border border-secondary text-center">{{ first_hundreds }}</div>
            </div>
            <div class="col-4">
              <div class="group-digit border border-secondary text-center">{{ first_tens }}</div>
            </div>
            <div class="col-4">
              <div class="group-digit border border-secondary text-center">{{ first_units }}</div>
            </div>
          </div>
          <div class="row no-gutters" v-else>
            <div class="col-6">
              <div class="group-digit border border-secondary text-center">{{ first_tens }}</div>
            </div>
            <div class="col-6">
              <div class="group-digit border border-secondary text-center">{{ first_units }}</div>
            </div>
          </div>
          <div class="group-label">{{ first_label }}</div>
        </div>
        <div class="group-separator">:</div>
        <div class="text-center ">
          <div class="row no-gutters">
            <div class="col-6">
              <div class="group-digit border border-secondary text-center">{{ second_tens }}</div>
            </div>
            <div class="col-6">
              <div class="group-digit border border-secondary text-center">{{ second_units }}</div>
            </div>
          </div>
          <div class="group-label">{{ second_label }}</div>
        </div>
        <div class="group-separator">:</div>
        <div class="text-center ">
          <div class="row no-gutters">
            <div class="col-6">
              <div class="group-digit border border-secondary text-center">{{ third_tens }}</div>
            </div>
            <div class="col-6">
              <div class="group-digit border border-secondary text-center">{{ third_units }}</div>
            </div>
          </div>
          <div class="group-label">{{ third_label }}</div>
        </div>
        </div>



    </div>
</template>

<script>

    /* eslint-disable */

    import TimPartyMixin from '../mixins/TimPartyMixin';

    export default {
      name: 'Countdown',
      mixins: [ TimPartyMixin ],
      props: {
        tsEnd: String,
        heading: String,

      },
      data: function(){

        return {

          end: null,
          distance: 0,
          days: 0,

          first_hundreds: '',
          first_tens: '',
          first_units: '',
          first_label: '',
          second_tens: '',
          second_units: '',
          second_label: '',
          third_tens: '',
          third_units: '',
          third_label: '',


          timer: null,

        };
      },
      mounted: function(){

        this.Update();
        var self = this;
        this.end = this.tsEnd;

        self.Update();
        this.timer = setInterval( function(){
          self.Update();
        }, 1000 );


      },

      methods: {
        Update: function(){


          var now = new Date().getTime();


          var distance = (this.end * 1000) - now;
          if(distance < 0)
            distance = 0;

          this.distance = distance;

          var first, second, third;

          this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
          var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);

          if(this.days > 0){
            first = this.padNumber(this.days, 2);
            second = this.padNumber(hours, 2);
            third = this.padNumber(minutes, 2);
            this.first_label = this.__('Giorni');
            this.second_label = this.__('Ore');
            this.third_label = this.__('Minuti');
          }
          else{
            first = this.padNumber(hours, 2);
            second = this.padNumber(minutes, 2);
            third = this.padNumber(seconds, 2);
            this.first_label = this.__('Ore');
            this.second_label = this.__('Minuti');
            this.third_label = this.__('Secondi');
          }


          this.first_tens = first.charAt(0);
          this.first_units = first.charAt(1);
          if (this.days >= 100) {
            this.first_hundreds = first.charAt(0);
            this.first_tens = first.charAt(1);
            this.first_units = first.charAt(2);
          } else {
            this.first_tens = first.charAt(0);
            this.first_units = first.charAt(1);
          }

          this.second_tens = second.charAt(0);
          this.second_units = second.charAt(1);

          this.third_tens = third.charAt(0);
          this.third_units = third.charAt(1);



        },
      },
      computed: {

      }
    }
  </script>


